if (!customElements.get('product-engraving')) {
  class productEngraving extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('[name="engraving"]');
      this.baseFont = parseInt(this.querySelector('[data-engraving-base-font]').dataset.engravingBaseFont);
      this.modalSelector = `.engraving-modal--${this.input.dataset.productId}`;
      this.modals = document.querySelectorAll(this.modalSelector);
      this.textEls = document.querySelectorAll(this.modalSelector + ' .engraving-modal__text');
      this.addButton = this.querySelector('[data-action="add-engraving"]');
      this.removeButton = this.querySelector('[data-action="remove-engraving"]');
      this.showButton = this.querySelector('[data-action="show-engraving"]');
      this.closeButtons = document.querySelectorAll('[data-action="close-engraving"]');
      this.limitCount = parseInt(this.querySelector('[data-characters-left]').dataset.limit);
      this.charsLeftEl = this.querySelector('[data-characters-left]');
      this.info = this.querySelector('.icon-info');
      this.PDClose = this.querySelector('.PDPopup__close');
      this.update();

      this.input.addEventListener('focusin', this.openModal.bind(this));
      this.showButton.addEventListener('click', this.openModal.bind(this));

      this.closeButtons.forEach((button) => button.addEventListener('click', this.closeModal.bind(this)));
      this.addButton.addEventListener('click', this.addEngraving.bind(this));
      this.removeButton.addEventListener('click', this.removeEngraving.bind(this));

      this.input.addEventListener('input', this.inputHandler.bind(this));
      window.addEventListener('resize', this.update.bind(this));

      if (this.info) this.info.addEventListener('click', this.showPopup.bind(this));
      if (this.PDClose) this.PDClose.addEventListener('click', this.hidePopup.bind(this));
    }
    showPopup() {
      document.querySelector('.engraving_popup').classList.toggle('PDPopup--visible');
    }
    hidePopup() {
      document.querySelector('.engraving_popup').classList.remove('PDPopup--visible');
    }
    openModal(evt) {
      document.querySelectorAll('product-engraving').forEach((item) => item.closeModal());

      const windowScollY = window.scrollY;
      this.closest('.product').classList.add('product--engraving-is-active');
      this.modals.forEach((modal) => modal.classList.add('engraving-modal--active'));
      this.querySelector('.product-engraving').classList.add('product-engraving-is-active');

      this.update();
      this.preventStickyHeader();
      // this.input.scrollIntoView({behavior: "smooth", block: "end"});
      setTimeout(() => {
        document.querySelector('.product-engraving').scrollIntoView({ block: 'end' });
      }, 1);
    }

    closeModal(evt) {
      this.closest('.product').classList.remove('product--engraving-is-active');
      this.modals.forEach((modal) => modal.classList.remove('engraving-modal--active'));
      this.querySelector('.product-engraving').classList.remove('product-engraving-is-active');
      window.dispatchEvent(new Event('resize')); // for flickity to resize
    }

    getFont() {
      var ratio = this.baseFont / 715; // calc ratio
      var size = this.activeModal.querySelector('.engraving-modal__image-wrapper').clientWidth * ratio; // get font size based on current width
      return size | 0; // set font
    }

    setFont() {
      const textFont = this.getFont();
      this.textEls.forEach((text) => (text.style.fontSize = textFont + 'px'));
    }

    update() {
      this.mql = window.matchMedia('(min-width: 750px)').matches;
      this.activeModal = this.mql ? this.modals[0] : this.modals[1];
      // console.log(this.activeModal);
      this.setFont();
      setTimeout(() => window.setBackground(), 1);
    }

    inputHandler(e) {
      this.input.value = this.input.value.replace(/[^a-zA-Z0-9 ]/gm, '').toUpperCase();
      this.textEls.forEach((text) => (text.innerHTML = this.input.value));
      this.charsLeftEl.innerHTML = this.limitCount - this.input.value.length;
    }

    addEngraving(e) {
      if (this.input.value.length == 0) return;
      this.querySelector('[name="engraving-preview"]').value = this.input.value;
      this.querySelector('.product-engraving').classList.add('engraving-modal--engraving-added');
      this.preventStickyHeader();
      setTimeout(() => {
        document.querySelector('.product-form-block_buy-buttons').scrollIntoView({ block: 'end' });
      }, 1);
      // this.closeModal();
      this.updatePrice(true);
    }

    removeEngraving() {
      this.querySelector('.product-engraving').classList.remove('engraving-modal--engraving-added');
      this.updatePrice(false);
    }

    updatePrice(engravingAdded) {
      const engravingPrice = parseInt(this.querySelector('[data-engraving-price]').dataset.engravingPrice);
      const priceWrapper = document.querySelector(
        `#price-${this.querySelector('[data-section-id]').dataset.sectionId}`
      );
      if (!priceWrapper) return;
      let priceEL;
      if (priceWrapper.querySelector('.money')) {
        priceEL =
          priceWrapper.querySelector('.price--on-sale .price-item--sale .money') ||
          priceWrapper.querySelector('.price-item--regular .money');
      } else {
        priceEL =
          priceWrapper.querySelector('.price--on-sale .price-item--sale') ||
          priceWrapper.querySelector('.price-item--regular');
      }

      if (!priceEL) return;
      if (engravingAdded) {
        priceEL.innerHTML = Shopify.formatMoney(parseInt(priceWrapper.dataset.currentPrice) + engravingPrice);
      } else {
        priceEL.innerHTML = Shopify.formatMoney(parseInt(priceWrapper.dataset.currentPrice));
      }
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
  }

  customElements.define('product-engraving', productEngraving);
}
